<template>
  <section>
    <div class="categories">
        <Adsense
          data-ad-client="ca-pub-8143206471999291"
          data-ad-slot="2977683526">
        </Adsense>
        <div class="columns">
          <div class="column main_bar is-8">
            <h1>『{{this.$route.params.id}}』の夢占い一覧</h1>
            <p>（{{this.categories[0].contents.length}}件）</p>
            <div class="category_list" v-for="category in this.categories[0].contents" :key="category.id">
              <router-link :to="{name:'article', params:{ id: category.title}}"><li>{{category.title}}</li></router-link>
              <hr class="category_border"> 
            </div>
            <Adsense
              data-ad-client="ca-pub-8143206471999291"
              data-ad-slot="6972768854">
            </Adsense>
          </div>
          <div class="column side_bar">
            <p>キーワード検索</p>
            <SearchComponent/>
            <div class="category_component_category">
              <h2>よく見る夢</h2>
              <ThemesComponent/>
            </div>
            <h2>50音順</h2>
            <InitialComponent/>
            <h2>カテゴリーの一覧</h2>
            <CategoryComponentCategory/>
            <div class="side_ad">
              <Adsense
                data-ad-client="ca-pub-8143206471999291"
                data-ad-slot="3701076989">
              </Adsense>
            </div>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import store from '@/store';
import SearchComponent from '@/components/SearchComponent'
import CategoryComponentCategory from '@/components/CategoryComponentCategory'
import InitialComponent from '@/components/InitialComponent.vue'
import ThemesComponent from '@/components/ThemesComponent.vue'
export default {
  components: {
    SearchComponent,
    CategoryComponentCategory,
    InitialComponent,
    ThemesComponent
  },
  data() {
    return {
      categories:  [],
      initialFlag: "",
    };
  },
  watch: {
    '$route' (to) {
        store.commit('start');
        this.$router.go(to.params.id)
    }
  },
  created() {
      store.commit('start')
      let url = "https://dream.microcms.io/api/v1/article?filters=category[equals]" + this.$route.params.id + "&limit=1000"
        axios
            .get(url, {
            headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
            })
            .then(res => {
              if(res.data.totalCount != 0){
                this.categories.push(res.data)
                this.sortedItemsByName()
                store.commit('end');
              }
            }).catch(err => {
                console.log(err);
                store.commit('end');
            });
      const title = "「" + this.$route.params.id + "」" + "の夢占い・夢診断・夢解釈｜夢占い辞典ゆめみん"
      const description = "「" + this.$route.params.id+ "」"  + "の夢占い一覧"
      const twitter_image = 'https://dream.ameneko.com/ogpImage.jpeg'
      const og_image = 'https://dream.ameneko.com/topImage.jpeg'
      document.title = title
      document.querySelector("meta[property='og:image']").setAttribute('content', og_image)
      document.querySelector("meta[name='twitter:image']").setAttribute('content', twitter_image)
      document.querySelector("meta[property='og:title']").setAttribute('content', title)
      document.querySelector("meta[name='description']").setAttribute('content', description)
      document.querySelector("meta[property='og:description']").setAttribute('content', description)   
    },
    methods:{
      sortedItemsByName(){
        var vm = this
        vm.categories[0].contents.sort((a, b) => {
          return (a.spelling < b.spelling) ? -1 : (a.spelling > b.spelling) ? 1 : 0;
        });
      },
    }
  }
</script>

<style scoped>
.categories{
  padding:20px;
}
h1{
  font-weight: bold;
  font-size: 1.5em;
  border-bottom: solid 2px #27556A;
}
h2{
  font-weight: bold;
  font-size: 1.1em;
  border-bottom: solid 2px #27556A;
  margin: 20px 0 20px 0;
}
h3{
  font-weight: bold;
  font-size: 1.2em;
  padding-top: 10px;
  padding-bottom: 10px;
}
.category_list{
  font-size: 1.1em;
  padding: 5px 0 5px 16px;
}
li{
  position: relative;
  list-style-type: none;
}
li::after {
  display: block;
  content: '';
  position: absolute;
  top: .5em;
  left: -1em;
  width: 6px;
  height: 6px;
  border-right: 1px solid #666;
  border-bottom: 1px solid #666;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.category_component_category{
  margin: 30px 0 30px 0;
}
.category_border{
  margin: 4px 4px 4px 0;
  border:none;
  border-top:dashed 1px #e8e8e8;
  height:1px;
  color:#FFFFFF;
}
.main_bar{
  margin: 0 5px 0 5px;
}
.side_bar{
  margin: 0 5px 0 5px;
}
.side_ad{
  margin: 20px 0 0 0;
}
</style>